export class RelatorioVendasCanaisDto {
  quantidades: number[];
  valores: number[];
  canais: string[];

  constructor() {
    this.quantidades = [];
    this.valores = [];
    this.canais = [];
  }
}
